module.exports = __webpack_public_path__ + "images/help/guide_video_doc-449eaf113cb67b11878c072d469dd985.png";